<template>
	<div id="dspay" class="page">
		<div class="container">
			<div class="thumb-slider layui-carousel" id="thumbSlider" v-if='info.thumbs'>
				<swiper :options="swiperOption">
					<swiper-slide v-for="(item,index) in attachments" :key="index"><img :src="item" class="swiper-img"></swiper-slide>
				</swiper>
			</div>
			<div class="price-info">
				<div>
					<label for="">价格：</label>
					<span class="field-val">{{info.price}}</span>
					<span class="field-unit">/元</span>
				</div>
				<div>
					<label for="">使用时长：</label>
					<span class="field-val">{{info.working_time}}</span>
					<span class="field-unit">/分钟</span>
				</div>
			</div>
			<div v-html='info.detail' class="device-detail" v-bind:class="{'':1 == info.status,enabled:0 == info.status}"></div>
			<div class="btn-group">
				<button type="button" v-on:click="event_pay" class="layui-btn layui-btn-lg layui-btn-warm payconfirm" v-if='0 == info.status'>支付</button>
			</div>
		</div>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		info:{},
		sn:'',
		swiperOption:{
			slidesPerView: 'auto',
			centeredSlides:true,
			spaceBetween: 10,
			loop:true,
			speed:600, //config参数同swiper4,与官网一致
			autoplay:true
		},
		attachments:[]
	}
  },
  mounted () {
	
  },
  created(){
	  this.sn = this.$route.query.devicesn
	  this.$app.pr('/wechat/devices/info',{
			devicesn:this.sn
	  }).then((res) => {
		this.info = res.data.info
		for(var n in this.info.thumbs){
			console.log(this.info.thumbs[n])
			this.info.thumbs[n] = this.info.thumbs[n].replace('web.','work.');
		}
		this.attachments = this.info.thumbs
		console.log(this.attachments);
	  }).catch((res) => {
		this.$wx.showToast('加载失败')
		//this.$wx.navigateBack();
	  });
  },
  methods:{
	event_pay(){

		this.$wx.showLoading('正在处理')
		this.$app.pr('/wechat/orders/buy',{
			devicesn:this.sn
		}).then((res) => {
			this.$wx.hideLoading()
			if(!res.success){
				this.$wx.showToast(res.msg)
				return false;
			} 
			this.$app.pr('/wechat/orders/pay',{
				tradesn:res.data.trade_sn
			}).then((res) => {
				if(!res.success){
					this.$wx.showToast(res.msg)
					return false;
				}
				this.$wx.requestPayment(res.data.payinfo).then((ress) => {
					this.$wx.navigateTo({
						url: '/payresult?order_sn=' + res.data.trade_sn+'&type=dg',
					});
				}).catch((res) => {
					this.$wx.showToast({
						title: '支付失败',
					});
				})
			}).catch((res) => {
				this.$wx.hideLoading()
				this.$wx.showToast('支付失败，请重试')
			});
		}).catch((res) => {
			this.$wx.hideLoading()
			this.$wx.showToast('支付失败，请重试')
		});
	}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#dspay{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.swiper-img{
	height:100vw;
	display:block;
	width:100vw;
}
	/*消除图片的上下间隙*/
	img{vertical-align: bottom;display: block;}
	.device-detail{margin-top: 50px;padding: 10px;overflow-x: hidden;overflow-y: scroll;border-top: 1.5px dashed #999;}
	.device-detail.enabled{margin-bottom: 50px;}
	.device-detail p{font-size: 16px;overflow-x: hidden;}
	.btn-group{position: fixed;bottom: 0px;width: 100%;padding: 10px 16px 6px;background: #eeeeee;}
	.btn-group button{width: calc(100% - 32px)}
	.price-info{display: flex;justify-content: space-around;margin-top: 16px;}
	.field-val{font-size: 36px;color: #FF5722;}
	.field-unit{font-size: 12px;color: #c2c2c2;}
	
	.pay-modal{display: none;}
	.pay-modal.active{display: block;}
	.qrcode-modal{display: none;width: 100%;height: 100%;overflow: hidden;}
	.qrcode-modal.active{display: block;}
	.qrcode-img{width: 100%;}
	.layui-btn{
		background:linear-gradient(to right, #fa8d60, #e76025);
		    height: 12vw;
			display: block;
			margin: 0vw 3vw;
			text-align: center;
			color: #FFFFFF;
			background: -webkit-gradient(linear, left top, right top, from(#fa8d60), to(#e76025));
			background: linear-gradient(to right, #fa8d60, #e76025);
			font-size: 4vw;
			line-height: 12vw;
			border-radius: 10px;
			border:0px;
	}
	.btn-group{
		padding:3vw 0vw;
	}
</style>


// WEBPACK FOOTER //
// src/components/Dgpay.vue